import './manage_users.css'
import parseDomain from 'parse-domain'
import { compose } from 'ramda'
import * as R from 'ramda'
/*eslint-disable*/
import React, { useEffect, useState } from 'react'

import { Error } from '@/common/components/ErrorBoundary'
import { Loader } from '@/common/components/Loader'
import { Modal } from '@/common/components/Modal'
import { Button, Input } from '@/common/styled/Dialog.BotDetails.Dumb'
// import { ButtonContainer } from '@/common/styled/Dialog.Canvas.Nodes.Dumb'

import { getCurrentUserInfo } from '@/common/utils/utils'
import { logEvent, stripeGetApi } from '@/common/utils/api-utils'
import User from './User'
import blockedDomains from './blocked_email'
import {
    BasicUserInfo,
    disableUser,
    enableUser,
    getAllowedNumberOfAdminsApi,
    getUsersAPI,
    inviteUser,
    removeUser
} from './op.manageUsers'
import { UserCallebacks, User as UserT } from './types.user'
import styled from 'styled-components'


export const InputContent = styled.div`
    color: #999;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: 18px;
    transition: 0.26s ease-in;
    ${Input}:focus ~ &,
    ${Input}:not(:placeholder-shown).input:not(:focus) ~ .label,
    ${Input}:valid ~ & {
        top: 10px;
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
    }
`

export const ButtonContainer = styled.div`
    width: 100%;
    float: left;
    position: relative;
    bottom: 0;
    background: #fff;
    display: flex;
    justify-content:  ${props => (props.align && props.align == 'left' ? 'flex-start' : 'center')};
    padding-top: ${props => (props.padding ? '10px' : '0px')};
    padding-bottom: 20px;

        ${Button}{
            text-align:center;
            justify-content: center;
            margin:0px;
            :first-child{
                margin-right:10px;
            }
        }
    }
    
`

const getDomain = (url: string) =>
    R.compose<string, any, string, string>(
        R.ifElse(R.startsWith('.'), R.slice(1, Infinity), R.identity),
        R.converge(R.unapply(R.join('.')), [R.prop('subdomain'), R.prop('domain'), R.prop('tld')]),
        parseDomain
    )(url)

const domainIsExistedInBlackList = (domain: any) => {
    return R.findIndex(R.equals(domain), blockedDomains) !== -1
}

const isBlockedDomain = R.compose(domainIsExistedInBlackList, getDomain)

const Title = ({ inviteClicked, showInviteBtn = true }: any) => (
    <React.Fragment>
        <div className="manage_user_line d-flex align-items-baseline w-100 float-left">
            <h5>Add users to your workspace:</h5>
            {showInviteBtn ? (
                <Button onClick={inviteClicked}>
                    <span>
                        <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
                            <path d="m512 412c0 11.046875-8.953125 20-20 20h-60v60c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20v-60h-60c-11.046875 0-20-8.953125-20-20s8.953125-20 20-20h60v-60c0-11.046875 8.953125-20 20-20s20 8.953125 20 20v60h60c11.046875 0 20 8.953125 20 20zm-160 80c0 11.046875-8.953125 20-20 20h-272c-33.085938 0-60-26.914062-60-60v-37c0-34.515625 14.804688-67.3125 40.613281-89.988281 20.894531-18.363281 60.910157-45.578125 125.238281-59.722657-35.15625-27.082031-57.851562-69.582031-57.851562-117.289062 0-81.605469 66.394531-148 148-148s148 66.394531 148 148-66.394531 148-148 148c-109.902344 0-168.777344 41.300781-188.984375 59.058594-17.167969 15.085937-27.015625 36.929687-27.015625 59.941406v37c0 11.027344 8.972656 20 20 20h272c11.046875 0 20 8.953125 20 20zm-96-236c59.550781 0 108-48.449219 108-108s-48.449219-108-108-108-108 48.449219-108 108 48.449219 108 108 108zm0 0" />
                        </svg>
                    </span>
                    <label>Invite User</label>
                </Button>
            ) : null}
        </div>
    </React.Fragment>
)

const isValidEmail = R.test(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
)

type InvitationPopupP = {
    currentUser: any
    ws: string
    callbacks: {
        cancel: () => null | void
        completed: (userInfo: BasicUserInfo) => null | void
        failed: (err: Error, user: BasicUserInfo) => any
    }
}

const capitalize = (string: any) =>
    R.ifElse(
        R.isEmpty,
        R.always(''),
        R.compose(R.flip(R.concat)(R.slice(1, Infinity, string)), R.toUpper, R.head)
    )(string)

const replaceUnAlpha = R.replace(/[^a-zA-Z]/g, '')

const normalize = (name: string) =>
    (name.length && name[0] + R.compose<string, string, string>(R.toLower, R.slice(1, Infinity))(name)) || ''

const allowOnlyAlpha: (val: any) => any = R.ifElse(
    R.isEmpty,
    R.always(''),
    R.compose(normalize, capitalize, replaceUnAlpha)
)

const InviteUserPopUp = ({ ws, callbacks: { cancel, completed, failed }, currentUser }: InvitationPopupP) => {
    const [first_name, setFirstName] = useState('')
    const [last_name, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [emailValidation, setEmailValidation] = useState<{ valid: boolean; message: any }>({
        valid: true,
        message: null
    })
    const [err, setErr] = useState<any>(null)
    const [loading, showLoading] = useState<boolean>(false)

    const userInfo: BasicUserInfo = {
        first_name: first_name.length ? first_name : undefined,
        last_name: last_name.length ? last_name : undefined,
        email
    }

    const submit = async function() {
        try {
            showLoading(true)
            await inviteUser(ws, userInfo)
            logEvent(ws, {
                event:"EVENT::INVITE_USER::INVITE_TO_WORKSPACE", event_meta:{}
            })
            showLoading(false)
            completed(userInfo)
        } catch (e) {
            showLoading(false)
            setErr(failed(e, userInfo))
        }
    }

    const errComponent = err ? (
        <React.Fragment>
            {err}
            <Button primary onClick={submit} type="button">
                <label>Retry</label>
            </Button>
        </React.Fragment>
    ) : null

    return (
        <Modal close={!loading ? cancel : () => {}} showPopupLoader={loading}>
            {errComponent || (
                <React.Fragment>
                    <h2>Invite New User </h2>
                    <div>
                        <div className="account_popup_user_input automate">
                            <div className="form-row">
                                <div className="form-group col-md-12">
                                    {/* <label>First Name</label> */}
                                    <Input
                                        type="text"
                                        className="form-control"
                                        // placeholder="Enter first name"
                                        value={first_name}
                                        onChange={(e:any) => {
                                            setFirstName(allowOnlyAlpha(e.target.value))
                                        }}
                                    />
                                    <InputContent className="input_content">Enter first name</InputContent>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-12">
                                    {/* <label>Last Name</label> */}
                                    <Input
                                        type="text"
                                        className="form-control"
                                        // placeholder="Enter last name"
                                        value={last_name}
                                        onChange={(e:any) => {
                                            setLastName(allowOnlyAlpha(e.target.value))
                                        }}
                                    />
                                    <InputContent className="input_content">Enter last name</InputContent>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-12">
                                    {/* <label>Email Address</label> */}
                                    <Input
                                        type="email"
                                        className="form-control"
                                        // placeholder="Enter email id"
                                        value={email}
                                        onChange={(e:any) => {
                                            const email = e.target.value
                                            const formatIsValid = isValidEmail(email)
                                            const emailIsSameAsLoggedInUser = currentUser.email === email
                                            const isValid =
                                                formatIsValid && !emailIsSameAsLoggedInUser && !isBlockedDomain(email)
                                            setEmailValidation({
                                                valid: isValid,
                                                message: formatIsValid
                                                    ? emailIsSameAsLoggedInUser
                                                        ? "You can't invite yourself"
                                                        : 'Only corporate emails are allowed'
                                                    : 'Email is invalid'
                                            })
                                            setEmail(email)
                                        }}
                                    />
                                    <InputContent className="input_content">Enter mail id</InputContent>
                                    {!emailValidation.valid && <p className="error_msg">{emailValidation.message}</p>}
                                </div>
                            </div>
                        </div>

                        <ButtonContainer className="pb-0">
                        <Button primary onClick={cancel} type="button">
                            <label>Cancel</label>
                        </Button>
                        <Button disabled={!isValidEmail(email)} onClick={submit} type="button">
                            <label>Send Invite</label>
                        </Button>
                        </ButtonContainer>
                    </div>
                </React.Fragment>
            )}
        </Modal>
    )
}

type ConfirmationOnActionP<T> = {
    user: UserT | null
    confirmation: {
        title: string
        message: any
        actionBtn: string
        cancelBtn: string
        primary: 'actionBtn' | 'cancelBtn'
    }
    doAction: (user: UserT) => Promise<T>
    failed: (err: Error) => any
    canceled: () => null | void
}

const ConfirmationPopUp = function<T>(props: ConfirmationOnActionP<T>) {
    const [err, setError] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const doAction = async function() {
        try {
            setLoading(true)
            const doingAction = props.user ? props.doAction(props.user) : Promise.resolve(null)
            await doingAction
        } catch (e) {
            setLoading(false)
            setError(props.failed(e))
        }
    }

    const cancelBtnClass = props.confirmation.primary === 'cancelBtn' ? 'btn btn-success' : 'btn btn-primary'
    const actionBtnClass = props.confirmation.primary === 'actionBtn' ? 'btn btn-success' : 'btn btn-primary'

    const errComponent = err ? (
        <React.Fragment>
            {err}
            <Button primary onClick={doAction} type="button">
                Retry
            </Button>
        </React.Fragment>
    ) : null

    return (
        <Modal showPopupLoader={loading} close={loading ? () => {} : props.canceled}>
            {errComponent || (
                <React.Fragment>
                    <h2>{props.confirmation.title}</h2>
                    <p>{props.confirmation.message}</p>
                    <ButtonContainer className="pb-0" style={{marginTop: 20, marginLeft: 0, justifyConten: 'center'}}>
                        <Button primary onClick={props.canceled} type="button">
                            <label>{props.confirmation.cancelBtn}</label>
                        </Button>
                        <Button onClick={doAction} type="button">
                            <label>{props.confirmation.actionBtn}</label>
                        </Button>
                    </ButtonContainer>
                </React.Fragment>
            )}
        </Modal>
    )
}

type confirmationInfo = {
    callbacks: { close: () => null | void; completed: (user: UserT) => null | void }
    ws: string
}

const confirmToRemove = (info: confirmationInfo) => (user: UserT): ConfirmationOnActionP<any> => ({
    user,
    confirmation: {
        title: user.verified ? 'Remove User' : 'Cancel Invite',
        message: user.verified ? 'Are you sure want to remove this user ?' : 'Are you sure want to cancel this invite?',
        actionBtn: 'Yes',
        cancelBtn: 'Cancel',
        primary: 'actionBtn'
    },
    canceled: info.callbacks.close,
    doAction: user => {
        return removeUser(info.ws)(user.id).then(() => {
            return info.callbacks.completed(user)
        })
    },
    failed: err => 'Server Error! Please try again'
})

const confirmToEnable = (info: confirmationInfo) => (user: UserT): ConfirmationOnActionP<any> => ({
    user,
    confirmation: {
        title: 'Provide User Access',
        message: 'Are you sure to provide the workspace access to the user?',
        actionBtn: 'Yes',
        cancelBtn: 'No',
        primary: 'actionBtn'
    },
    canceled: info.callbacks.close,
    doAction: user => {
        return enableUser(info.ws)(user.id).then(() => {
            return info.callbacks.completed(user)
        })
    },
    failed: err => 'Server Error! Please try again'
})

const confirmToDisable = (info: confirmationInfo) => (user: UserT): ConfirmationOnActionP<any> => ({
    user,
    confirmation: {
        title: 'Remove User Access',
        message: 'Are you sure to remove the workspace access to the user?',
        actionBtn: 'Yes',
        cancelBtn: 'No',
        primary: 'actionBtn'
    },
    canceled: info.callbacks.close,
    doAction: user => {
        return disableUser(info.ws)(user.id).then(() => {
            return info.callbacks.completed(user)
        })
    },
    failed: err => 'Server Error! Please try again'
})

const confirmToInvite = (info: confirmationInfo) => (): ConfirmationOnActionP<any> => ({
    user: null,
    confirmation: {
        title: 'Invite New User',
        message: 'Are you sure to remove the workspace access to the user?',
        actionBtn: 'Yes',
        cancelBtn: 'No',
        primary: 'actionBtn'
    },
    canceled: info.callbacks.close,
    doAction: user => {
        return disableUser(info.ws)(user.id).then(() => {
            return info.callbacks.completed(user)
        })
    },
    failed: err => 'Server Error! Please try again'
})

const isCurrentUserIsAdmin = (user: any, users: any) =>
    R.compose(R.pathEq(['WorkspaceAccess', 'accessLevel'], 'admin'), R.find(R.propEq('id', R.prop('id', user))))(users)

export const ManageUsers = function(props: any) {
    const workspace = props.match.params.workspacename
    const [users, setUsers] = useState<UserT[]>([])
    const [err, setError] = useState<number>(200)
    const [confirmation, confirmPopUp] = useState<ConfirmationOnActionP<any> | null>(null)
    const [showInvitePopup, invitePopUp] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [isAdminUser, currentUserIsAdmin] = useState<boolean>(false)
    const [loggedInUser, setLoggedInUser] = useState<any>(null)
    const [allowedAdmins, setAllowedAdmins] = useState(0)
    const [hasValidSubscriptionStatus, setHasValidSubscriptionStatus] = useState<boolean>(true)
    const closeConfirmation = () => confirmPopUp(null)
    const closeInvitePopup = () => invitePopUp(false)

    useEffect(() => {
        async function fetchAPI() {
            try {
                const [users, currentUser, numberOfAdminsAllowed, subscriptionData] = await Promise.all([
                    getUsersAPI(workspace),
                    getCurrentUserInfo(),
                    getAllowedNumberOfAdminsApi(workspace),
                    stripeGetApi(`${workspace}/subscription/current/lite`).then(data => data.output)
                ])
                // const [users, currentUser, numberOfAdminsAllowed, subscriptionData]:any = [
                //     [{"id":69,"first_name":"Abii","last_name":"Testtttttt","email":"abinaya.k@skitter.in","verified":true,"WorkspaceAccess":{"valid":true,"accessLevel":"user"}},{"id":70,"first_name":"Vinod","last_name":"Manda","email":"vinod.m@workativ.com","verified":true,"WorkspaceAccess":{"valid":true,"accessLevel":"admin"}},{"id":92,"first_name":"Abinaya","last_name":"Kumarasamy","email":"abinaya.k@workativ.com","verified":true,"WorkspaceAccess":{"valid":true,"accessLevel":"user"}}],
                //     {"id":70,"first_name":"Vinod","last_name":"Manda","email":"vinod.m@workativ.com","verified":true,"WorkspaceAccess":{"valid":true,"accessLevel":"admin"}},
                //     {"type":"success","output":{"displayName":"No of admins allowed","identifier":"ADMIN","resourceLimit":3,"resourceType":"finite"}},
                //     {"id":"9d75781b-eed7-43f1-83d5-986f581368d9","workspace":"vinodkumarsit","customerId":"cus_IC8tKwrHE75tqY","created_date":"2020-08-31T11:20:39.623Z","modified_date":"2020-08-31T11:20:39.000Z","subscription":{"id":"72afd17f-f0b4-4063-a297-9838c37b5491","stripeSubscriptionId":"sub_Ji6XHoPri63881","stripeProductSubscriptionId":"sub_Ji6XHoPri63881","status":"active","trialStartDate":"2020-08-31T11:20:40.000Z","trialEndDate":"2021-09-30T14:41:43.000Z","hasHadTrial":true,"created_date":"2020-08-31T11:20:39.636Z","modified_date":"2021-06-28T04:52:10.000Z","productPlan":{"id":"75f6aec8-68bf-460d-835c-884f8c984e3h","stripePlanId":"price_1J4fW8CQpfAeMPLfYnrTthbV","metaForUI":{"type":"Monthly","plans":"Pro","price":"799","steps":[{"category":"Chatbot Builder","hoverContent":"To built purposeful conversations"},{"category":"Workflow Builder","hoverContent":"To built automations to resolve an issue"},{"category":"VA on Multi chat channel","hoverContent":"Deploy the virtual assistant on a chat channel of your choice like Slack and Microsoft Teams"},{"bolder":"3","category":" Admins","hoverContent":"No of admins who can work on the application"},{"bolder":"5000","category":" Automation executions","hoverContent":"The total number of automations that can be executed over one month / 30 day period by the users."},{"bolder":"15000","category":" Conversation messages","hoverContent":"The total number of conversational messages sent to the virtual assistant over a one month / 30 day period by the users."},{"bolder":"10","category":" Active automations","hoverContent":" At a time, the number of active automations available for use in the Dialog Designer. Admin will be able to disable existing and enable new automations as per choice. "},{"bolder":"24 Hours","category":"  Response time ","hoverContent":"Response time to answer/resolve the client queries."},{"bolder":"Add-Ons","category":" for 0.01 $","hoverContent":"Additional cost for each automation execution and conversation message."},{"category":"Dialog Canvas","hoverContent":"Visual no-code canvas to create dialogs."}],"dollar":"$","priority":3,"referenceName":"PRO"},"created_date":"2020-06-22T22:35:58.407Z","modified_date":"2020-06-22T22:35:58.535Z","product":{"id":"54fe8ee9-fe18-40b4-9306-19b0c8f4b584","name":"ASSISTANT","displayName":"Workativ Assistant","description":null,"stripeProductId":"prod_HuojNzroW9vtLo","created_date":"2020-06-22T22:35:58.278Z","modified_date":"2020-06-22T22:35:58.349Z"},"plan":{"id":"bfd79f1c-bf25-46f7-8b8d-4cf732ba2870","name":"CUSTOM_PRO_OLD","displayName":"Classic Standard","billed":"Monthly","price":"999.00","created_date":"2020-06-22T22:41:13.975Z","modified_date":"2020-06-22T22:41:14.043Z"}},"hasTrialEnded":true},"trialPlan":{"defaultPlanId":"bfd79f1c-bf25-46f7-8b8d-4cf732ba2865","defaultPlanName":"TRIAL","defaultPlanDisplayName":"Trial","mappedPlanName":"CUSTOM_PRO_OLD","mappedPlanDisplayName":"Classic Standard","mappedPlanId":"75f6aec8-68bf-460d-835c-884f8c984e3h"}}
                // ]
                const subscription = subscriptionData.subscription
                currentUserIsAdmin(isCurrentUserIsAdmin(currentUser, users))
                setUsers(users)
                setAllowedAdmins(numberOfAdminsAllowed),
                    setHasValidSubscriptionStatus(
                        subscription.status === 'active' ||
                            (subscription.status === 'trialing' && subscription.hasTrialEnded === false)
                            ? true
                            : false
                    )
                setLoading(false)
                setLoggedInUser(currentUser)
            } catch (e) {
                setError(e.response ? e.response.status : 500)
                setLoading(false)
            }
        }
        fetchAPI()
    }, [loading])

    const confirmationPopUpConfig = {
        callbacks: {
            close: closeConfirmation,
            completed: () => {
                closeConfirmation()
                setLoading(true)
            }
        },
        ws: workspace
    }

    const userActions: UserCallebacks = {
        disableUser: compose(confirmPopUp, confirmToDisable(confirmationPopUpConfig)),
        enableUser: compose(confirmPopUp, confirmToEnable(confirmationPopUpConfig)),
        removeUser: compose(confirmPopUp, confirmToRemove(confirmationPopUpConfig))
    }

    const inviteUserProperties: InvitationPopupP = {
        currentUser: loggedInUser,
        ws: workspace,
        callbacks: {
            cancel: closeInvitePopup,
            failed: err => 'Something went wrong! Please try again',
            completed: () => {
                closeInvitePopup()
                setLoading(true)
            }
        }
    }

    return err === 200 ? (
        !loading ? (
            <React.Fragment>
                <section className="cogni_cards tour_automation_canvas">
                    <div className="header_box_shadow" />
                    <div className="flow_canvas1">
                        <div className="flex_canvas1">
                            <div className="flex_menu1 flow_group_home">
                                <div className="indent_dialog_left">
                                    <div className="indent_left">
                                        <div className="indent_title  mb-0">Manage Users</div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex_side_menu1 intent_home flow_group_home">
                                <div className="intent_dialog_right" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="cogni_cards fixed-top sup_acc_user_details z-index-1-important">
                    <div className="container float-left">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="sup_acc_user_details_header">
                                    <div className="automation_invite_user">
                                        <Title
                                            inviteClicked={() => invitePopUp(true)}
                                            showInviteBtn={
                                                isAdminUser &&
                                                users.length < allowedAdmins &&
                                                hasValidSubscriptionStatus
                                            }
                                        />
                                        <div className="manage_users_scroll">
                                            <div className="row">
                                                {users &&
                                                    users.map(user => (
                                                        <User
                                                            key={user.id}
                                                            user={user}
                                                            callbacks={userActions}
                                                            showAccessBtn={isAdminUser}
                                                        />
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {confirmation && <ConfirmationPopUp {...confirmation} />}
                {showInvitePopup && <InviteUserPopUp {...inviteUserProperties} />}
            </React.Fragment>
        ) : (
            <Loader.PageLoader show={loading} />
        )
    ) : err >= 400 && err < 500 ? (
        <Error.Unauthorized />
    ) : (
        <Error.PageLoadingError btnName="Retry Now" onClick={() => window.location.reload()} />
    )
}
